// extracted by mini-css-extract-plugin
module.exports = {"userGroupsListEntryBody":"sq-CXA21","userGroupsListEntryColumns":"_1mDPNu09","userGroupsNewBadge":"_19Y3YwIZ"};